var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash-page-new',{attrs:{"title":_vm.$t('Templates')}},[_c('h1',[_vm._v("Mailer Templates will be here")])])}
var staticRenderFns = []

export { render, staticRenderFns }